import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as s } from "../../../chunks/tslib.es6.js";
import o from "../../../core/Accessor.js";
import t from "../../../core/Collection.js";
import { property as r } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/ensureType.js";
import { subclass as e } from "../../../core/accessorSupport/decorators/subclass.js";
import { LineSnapper as i } from "./LineSnapper.js";
import { ParallelLineSnapper as p } from "./ParallelLineSnapper.js";
import { RightAngleSnapper as n } from "./RightAngleSnapper.js";
import { RightAngleTriangleSnapper as a } from "./RightAngleTriangleSnapper.js";
import { sortCandidatesInPlace as c } from "./snappingUtils.js";

var m = /*#__PURE__*/function (_o) {
  _inherits(m, _o);

  var _super = _createSuper(m);

  function m(s) {
    var _this;

    _classCallCheck(this, m);

    _this = _super.call(this, s), _this.updating = !1, _this._snappers = new t();
    return _this;
  }

  _createClass(m, [{
    key: "initialize",
    value: function initialize() {
      this._snappers.push(new p(this.view, this.options), new i(this.view, this.options), new n(this.view, this.options), new a(this.view, this.options));
    }
  }, {
    key: "options",
    set: function set(s) {
      this._set("options", s);

      var _iterator = _createForOfIteratorHelper(this._snappers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _o2 = _step.value;
          _o2.options = s;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "fetchCandidates",
    value: function () {
      var _fetchCandidates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(s, o) {
        var t, _iterator2, _step2, _r;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.options.effectiveSelfEnabled) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", []);

              case 2:
                t = [];
                _iterator2 = _createForOfIteratorHelper(this._snappers.items);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _r = _step2.value;
                    t.push.apply(t, _toConsumableArray(_r.snap(s, o)));
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                return _context.abrupt("return", (c(s, t), t));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchCandidates(_x, _x2) {
        return _fetchCandidates.apply(this, arguments);
      }

      return fetchCandidates;
    }()
  }]);

  return m;
}(o);

s([r({
  readOnly: !0
})], m.prototype, "updating", void 0), s([r({
  constructOnly: !0
})], m.prototype, "view", void 0), s([r()], m.prototype, "options", null), m = s([e("esri.views.interactive.snapping.SelfSnappingEngine")], m);
export { m as SelfSnappingEngine };